export type MidiExportFileNameOptions = {
  projectTitle: string;
  memo?: string;
  date: Date;
  version: number;
  detail?: string;
};

function safeSegment(value: string, fallback = "無題の曲"): string {
  const normalized = value
    .normalize("NFKC")
    .split("")
    .filter((character) => character.charCodeAt(0) >= 32)
    .join("")
    .replace(/[<>:"/\\|?*]+/g, "_")
    .replace(/\s+/g, " ")
    .replace(/_+/g, "_")
    .replace(/_+$/g, "")
    .replace(/[. ]+$/g, "")
    .trim();
  return (normalized || fallback).slice(0, 64);
}

export function midiExportTimestamp(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}`;
}

export function buildMidiExportFileName(options: MidiExportFileNameOptions): string {
  const parts = [safeSegment(options.projectTitle)];
  if (options.memo?.trim()) parts.push(safeSegment(options.memo, ""));
  if (options.detail?.trim()) parts.push(safeSegment(options.detail, ""));
  parts.push(midiExportTimestamp(options.date));
  parts.push(`v${Math.max(1, Math.round(options.version)).toString().padStart(2, "0")}`);
  return `${parts.filter(Boolean).join("_")}.mid`;
}
